import { EntityType } from "@mapmycustomers/shared/enum";

import EntityTypesSupportedInOutOfFrequency from "@app/types/dashboard/cards/outOfFrequency/EntityTypesSupportedInOutOfFrequency";

export const OUT_OF_FREQUENCY_ENTITY_TYPES: EntityTypesSupportedInOutOfFrequency[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
] as const;
